export const environment = {
  production: false,
  apiBaseUrl: 'https://dev.talentmarket.io/api/v1',
  bucketBaseUrl: 'https://storage.googleapis.com/publicpicstm',

  // Web analytics — prazan string = feature isključen.
  metaPixelId: '2339121106893973',
  ga4MeasurementId: '',
  cookiebotId: '7981cf52-370c-4241-b07a-47e5cc6da86e',
  webEventsEnabled: true,
};